import { useQuery } from '@tanstack/react-query';

import { ROUTES } from '#/config/routes';
import PageShell from '#/modules/infra/layout/PageShell';
import StockReturnOperateShell from '#/modules/imsMgmt/receipts/stockReturn/components/StockReturnOperateShell';
import { fetchWarehouseSelectOptions } from '#/modules/imsMgmt/settings/storePlace/helper/warehouseSelectOptions';
import WorkOrderStockOpsPageHeader from '#/modules/momMgmt/workOrder/components/WorkOrderStockOpsPageHeader';
import { lookupQueryKey } from '#/utils/queryKeys';

const WorkOrderReturnPage = () => {
  const warehouseQuery = useQuery({
    queryKey: lookupQueryKey('warehouseSelect'),
    queryFn: fetchWarehouseSelectOptions,
  });

  const warehouseOptions = warehouseQuery.data ?? [];

  return (
    <PageShell variant="formTall">
      <div className="layout-shell__body">
        <div>
          <WorkOrderStockOpsPageHeader page="return" variant="form" />

          <div className="sheet create_edit create_edit_form create_edit_form--page-scroll">
            <div className="create_edit_form__body pb-0!">
              <StockReturnOperateShell
                warehouseOptions={warehouseOptions}
                isWarehouseLoading={warehouseQuery.isLoading}
                successNavigateTo={ROUTES.workOrderReturn}
              />
            </div>
          </div>
        </div>
      </div>
    </PageShell>
  );
};

export default WorkOrderReturnPage;
